import { render, staticRenderFns } from "./NflPositionOpti.vue?vue&type=template&id=73132a88&scoped=true"
import script from "./NflPositionOpti.vue?vue&type=script&lang=js"
export * from "./NflPositionOpti.vue?vue&type=script&lang=js"
import style0 from "./NflPositionOpti.vue?vue&type=style&index=0&id=73132a88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73132a88",
  null
  
)

export default component.exports